import { render, staticRenderFns } from "./EditDefaultModal.vue?vue&type=template&id=35c7b744&"
import script from "./EditDefaultModal.vue?vue&type=script&lang=js&"
export * from "./EditDefaultModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports